var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayBillsForOthersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14492_4445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8993 19.26L26.114 19.2115M37.089 25.3998L25.6192 25.279M37.0022 31.9796L25.5641 31.84M36.9223 38.5295L25.4778 38.4152M30.0489 43.6223L25.4281 43.5765M13.2313 9.30826L43.7415 9.64679C46.8811 9.69245 49.408 12.2484 49.3624 15.388L48.9225 54.4371L45.7458 51.3654L42.6185 54.2318L39.719 51.4462L36.5919 54.3126L33.4151 51.2409L30.1034 54.3026L26.8825 51.1928L23.5073 54.2922L20.3306 51.2206L16.9555 54.32L17.4154 13.6061C17.4448 11.2704 15.567 9.33765 13.2249 9.33355C10.8892 9.30415 8.95642 11.1819 8.95231 13.5241L8.31761 28.5974L17.2475 28.4774",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5759,
    y: 17.6875,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#76BC21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2375 26.2927L47.5268 28.1433L51.9142 23.2266",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14492_4445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBillsForOthersIcon);
export default __webpack_public_path__ + "static/media/payBillsForOthersIcon.5ac7698e765db9e201021ae7e11a1ff9.svg";
export { ForwardRef as ReactComponent };